import { ProjectFragment, ProjectFragmentQuery } from '../../utils/gqlModels';
import { getProjectId } from '../../utils/idUtils';
import { Project } from '../../utils/model';
import { graphqlQuery } from './_graphqlQuery';

const query = `
${ProjectFragmentQuery}
query pj($pid: ID!) {
  project(fullPath: $pid) {
    ...ProjectFragment
  }
}
`;
interface ProjectGql {
  project: ProjectFragment | null;
}

export const mapProjectGql = (data: ProjectFragment): Project => ({
  id: getProjectId(data.id),
  name: data.name,
  fullPath: data.fullPath,
  webUrl: data.webUrl,
});

export const getProjectInfoGql = async (
  projectPath: string,
): Promise<Project | undefined> => {
  try {
    const res = await graphqlQuery<ProjectGql>(query, { pid: projectPath });
    const gqlProject = res.project;
    if (!gqlProject) return undefined;
    const obj: Project = mapProjectGql(gqlProject);
    return obj;
  } catch (e: any) {
    if (e?.response?.status === 404) {
      // not enough permissions
      console.error(e);
      return undefined;
    }
    throw e;
  }
};
